import * as React from 'react';

import { AdminUpgradeSharedQuote_sharedQuote_quoteData } from 'admin/queries/__generated__/AdminUpgradeSharedQuote';
import AdminUpgradeInfo from 'admin/components/AdminUpgradeInfo';
// @ts-ignore
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import AdminUpgradePlanQuoteBox from 'admin/components/AdminUpgradePlan/AdminUpgradePlanQuoteBox';
import EventTracking from 'lib/EventTracking';
import Row from 'components/Row';
import Text from 'components/Text';

import '../styles/AdminUpgradePlanSharedQuoteFound.scss';

type QuoteData = AdminUpgradeSharedQuote_sharedQuote_quoteData;

type Props = {
  quote: QuoteData;
  taxExempt: boolean;
  onTaxExemptChange: (taxExempt: boolean) => void;
};

class AdminUpgradePlanSharedQuoteFound extends React.Component<Props> {
  static trackingPrefix = 'admin_self_serve.shared_quote';

  componentDidMount() {
    this.track('view');
  }

  track = (key: string) => {
    EventTracking.trackKey(`${AdminUpgradePlanSharedQuoteFound.trackingPrefix}.${key}`);
  };

  handleTaxExemptChange = (taxExempt: boolean) => {
    this.track('tax_exempt.click');
    this.props.onTaxExemptChange(taxExempt);
  }

  render() {
    const { quote, taxExempt } = this.props;
    const title = quote.organization.type
      ? `${quote.organization.type} Remind Plan quote`
      : 'Your Remind Plan quote';
    const subtitle = quote.organization.type
      ? `Meaningful communication for every student, teacher, and parent at your ${quote.organization.type.toLowerCase()}`
      : 'Meaningful communication for every student, teacher, and parent.'

    return (
      <div className="AdminUpgradePlanSharedQuoteFound">
        <AdminUpgradePageHeader title="Purchase a Remind Plan" hideHelp />
        <div className="AdminUpgradePlanSharedQuoteFound-content">
          <div className="AdminUpgradePlanSharedQuoteFound-content-body">
            <div className="AdminUpgradePlanSharedQuoteFound-content-body-forms">
              <Row>
                <Text weight="semibold" size="xlarge" element="div">
                  {title}
                </Text>
                <Text size="medium" element="div">
                  {subtitle}
                </Text>
              </Row>
              <Row size="small">{AdminUpgradePlanQuoteBox({quote, taxExempt, onTaxExemptChange: this.handleTaxExemptChange})}</Row>
            </div>
            <div className="AdminUpgradePlanSharedQuoteFound-content-body--desktop-side">
              <Row size="xxxlarge">
                <AdminUpgradeInfo />
              </Row>
            </div>
          </div>
        </div>
        <div className="AdminUpgradePlanSharedQuoteFound--mobile-bottom">
          <div className="AdminUpgradePlanSharedQuoteFound-info-container">
            <AdminUpgradeInfo />
          </div>
        </div>
      </div>
    );
  }
}

export { AdminUpgradePlanSharedQuoteFound };
export default AdminUpgradePlanSharedQuoteFound;
